import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_CART':
      return action.cart
    default:
      return state
  }
}

export default reducer
